'use client';

import { classNames } from '@repo/ui/src/utils/classNames';
import UIContentGrid, { BackgroundStyle } from '@repo/ui/src/components/ContentGrid';
import ProductCard from '@repo/ui/src/components/Cards/ProductCard';
import RecipeCard from '@repo/ui/src/components/ContentGrid/RecipeCard';
import LearnCard from '@repo/ui/src/components/ContentGrid/LearnCard';
import { GridProps } from '@repo/ui/src/types/grid';
import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

interface MeaterContentGridProps {
  gridContent: GridProps['gridContent'];
  itemsPerRow: 3 | 4 | 5;
  header?: string;
  description?: string;
  link?: { link: string; displayName: string };
  _data?: any;
  backgroundStyle?: BackgroundStyle;
}

const MeaterContentGrid = ({
  gridContent,
  itemsPerRow,
  header,
  description,
  link,
  _data,
  backgroundStyle,
}: MeaterContentGridProps) => {
  const items = _data || gridContent.items;
  const isProduct = gridContent.gridType === 'product';

  if (!items || items.length === 0) return null;

  const isDark = backgroundStyle === 'Dark';

  return (
    <UIContentGrid
      itemsPerRow={itemsPerRow}
      header={header}
      description={description}
      link={link}
      backgroundStyle={backgroundStyle}
      isProduct={isProduct}
      sectionClassName={isDark ? 'bg-neutral-600' : 'bg-warm-100'}
      headerClassName={classNames(
        '!tra-text-web-heading-2',
        isDark ? 'text-white' : 'text-neutral-900',
      )}
      descriptionClassName={isDark ? 'text-neutral-100' : 'text-neutral-700'}
    >
      {gridContent.gridType === 'product' &&
        (items as Array<MeaterProduct>).map((product, index) => (
          <li key={product.id || index} className="h-full border border-warm-200 bg-white">
            <ProductCard
              product={product}
              image={product.previewImage}
            />
          </li>
        ))}

      {gridContent.gridType === 'recipe' &&
        items.map((recipe, index) => (
          <li key={recipe._meta?.deliveryId || index} className="h-full">
            <RecipeCard
              {...recipe}
              ratingSummary={recipe.ratingsAndReviews?.ratingSummary}
              backgroundStyle={backgroundStyle}
            />
          </li>
        ))}

      {gridContent.gridType === 'learn' &&
        items.map((article, index) => (
          <li key={article._meta?.deliveryId || index} className="h-full">
            <LearnCard {...article} backgroundStyle={backgroundStyle} />
          </li>
        ))}
    </UIContentGrid>
  );
};

export default MeaterContentGrid;
